import { call, put, takeLatest } from 'redux-saga/effects'

import { postModel, putModel, deleteModel } from '@galo-monitor/services/apis/galoMonitorApi/resources/model'

import { ModelActions, ModelTypes } from './duckModel'

function* saveModel({ model, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(model.id ? putModel : postModel , model)
    yield call(onSuccess)
  } catch (err) {
    yield put(ModelActions.modelError(err.message))
    yield call(onError, err)
  }
}

function* removeModel({ model, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteModel, model)
    yield call(onSuccess)
  } catch (err) {
    yield put(ModelActions.modelError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(ModelTypes.SAVE_MODEL, saveModel),
  takeLatest(ModelTypes.REMOVE_MODEL, removeModel)
]
